import { mergeObjectTypes } from '../cacheHelpers';

const AuthorizationResult = {
  merge: mergeObjectTypes
};

export default AuthorizationResult;
